import { Monitoring } from '../../../../app/routing/Sitemaps';

export const AlertNavController = [
    '$scope',
    'detectorWizardModal',
    'currentUser',
    'featureEnabled',
    function ($scope, detectorWizardModal, currentUser, featureEnabled) {
        const $ctrl = this;

        $scope.detectorWizardModal = detectorWizardModal;
        $scope.currentUser = currentUser;
        $scope.headerNavigation = [
            {
                id: Monitoring.map.id,
                label: featureEnabled('o11yNavDrawer') ? 'Active alerts' : Monitoring.map.label,
            },
        ];
        $ctrl.magneticPageHeader = featureEnabled('magneticPageHeader');
        $ctrl.o11yNavDrawer = featureEnabled('o11yNavDrawer');
        $ctrl.monitoringTabNavigation = featureEnabled('monitoringTabNavigation');

        this.$onInit = function () {
            this.setHierarchicalNav(Monitoring.name, Monitoring.IDs.alerts);
            $scope.setHierarchicalNav = this.setHierarchicalNav;
        };

        this.$onDestroy = function () {
            this.setHierarchicalNav();
        };
    },
];
